"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonConfigValue = exports.getConfigApi = void 0;
var env_1 = require("./env");
var constants_1 = require("../constants");
var getConfigValue = function (key, commonConfigApi) {
    if (!commonConfigApi) {
        return;
    }
    if (typeof commonConfigApi.getAll === 'function') {
        var config = commonConfigApi.getAll();
        return config && config[key];
    }
    return commonConfigApi[key];
};
exports.getConfigApi = function () {
    return env_1.getGlobal(function (g) {
        var context = (g.Wix && g.Wix.Utils) || g;
        return context && context.commonConfig;
    });
};
exports.getCommonConfigValue = function (key, commonConfigApi) {
    if (commonConfigApi === void 0) { commonConfigApi = exports.getConfigApi(); }
    var res = getConfigValue(key, commonConfigApi);
    return typeof res !== 'undefined' ? res : constants_1.DefaultCommonConfig[key];
};
//# sourceMappingURL=common-config.js.map